import { SessionInfo } from '../../../services/telemetry/telemetryService';
import { formatDate } from '../../../utils/formatUtils';

/** Coach-meaningful context for the archive modal (no internal UUIDs or import keys). */
export function getArchiveDialogDetailRows(
  session: Pick<SessionInfo, 'sessionDate' | 'team_id' | 'team_name' | 'boat_name' | 'crewName'>
): { label: string; value: string }[] {
  const dateStr = session.sessionDate?.trim();
  let dateDisplay = '—';
  if (dateStr) {
    try {
      dateDisplay = formatDate(dateStr);
    } catch {
      dateDisplay = dateStr;
    }
  }

  const rows: { label: string; value: string }[] = [
    { label: 'Date', value: dateDisplay },
    {
      label: 'Team',
      value: session.team_name?.trim() || (session.team_id ? '—' : 'Global (no team)'),
    },
    { label: 'Boat', value: session.boat_name?.trim() || '—' },
  ];

  if (session.crewName?.trim()) {
    rows.push({ label: 'Crew', value: session.crewName.trim() });
  }

  return rows;
}
